import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import { loadProjectDetailCollections } from '../redux/actions';
import ReactJson from 'react-json-view';
export const ViewItemDetails = ({
  isOpenItemDetail,
  hideModal,
  projectDetail,
  projectId,
  version,
  selectedItemWithDetails,
  selectedCollection,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadProjectDetailCollections({ projectId, version }));
  }, []);

  return (
    <Modal
      isOpen={isOpenItemDetail}
      toggle={hideModal}
      backdrop="static"
      style={{ maxWidth: '800px', marginTop: '70px' }}
    >
      <ModalHeader toggle={hideModal} className="border-bottom">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ width: '45rem' }}
        >
          <strong>Details</strong>
        </div>
      </ModalHeader>
      <ModalBody>
        <ReactJson
          name={false}
          iconStyle={'triangle'}
          enableClipboard={false}
          src={selectedItemWithDetails}
          theme="rvj-default"
          collapsed={false}
        />
      </ModalBody>
    </Modal>
  );
};
